var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card-layout',{attrs:{"items":_vm.categories},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var category = ref.item;
var layout = ref.layout;
return [_c('category-card',{attrs:{"category":category,"title-right":layout == 'wide',"to":_vm.link + '/' + category.id}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }